import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface FailedPaymentDetail {
  failedDate: string;
  parentName: string;
  parentEmail: string;
  studentName: string;
  productName: string;
  failedAmount: number;
}

export interface ReportingFailedPaymentsResponse {
  studioName: string;
  totalFailedAmount: number;
  failedPaymentDetails: Array<FailedPaymentDetail>;
}

export const reportingFailedPaymentsAPI = async (params: {
  startDate: string;
  endDate: string;
  format: string;
}): Promise<string | ReportingFailedPaymentsResponse> => {
  const isCSV = params.format === 'csv';
  const response = await baseAPI.get('/reporting/failed-payments', {
    params,
    responseType: isCSV ? 'text' : 'json',
  });
  if (isCSV) {
    return response.data as string;
  } else {
    return response.data as ReportingFailedPaymentsResponse;
  }
};

export const useReportingFailedPayments = (params: {
  startDate: string;
  endDate: string;
  format: string;
}) => {
  return useQuery({
    queryKey: [KEYS.FAILED_PAYMENTS, params],
    queryFn: () => reportingFailedPaymentsAPI(params),
    enabled: !!params.format,
  });
};
